<template>
    <div class="container">
        <v-btn>
            Normal
        </v-btn>
        <v-btn
            color="info"
        >
            Info
        </v-btn>
        <v-btn
            color="primary"
        >
            Primary
        </v-btn>
        <v-btn
            color="warning"
        >
            Warning
        </v-btn>
        <v-btn
            color="success"
        >
            Success
        </v-btn>
        <v-btn
            color="error"
        >
            Error
        </v-btn>
        <v-btn
            disabled
        >
            Disabled
        </v-btn>
    </div>
</template>

<script>
export default {}
</script>
